import { library } from '@fortawesome/fontawesome-svg-core';
import { faTidal } from './tidalIcon';
import { faDeezer } from './deezerIcon';

library.add(faTidal, faDeezer);

export { faTidal, faDeezer };